import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "../pages/Modules/Dashboard";
import Employee from "../pages/Modules/Employee";
import Settings from "../pages/Settings";
import EmployeeProfile from "../pages/EmployeeProfile";
import Branch from "../pages/Branch";
import Users from "../pages/Users";
import JobTitle from "../pages/JobTitle";
import Department from "../pages/Department";
import Role from "../pages/Role";
import Client from "../pages/Client";
import ImportHistory from "../pages/importPage";
import AuditLogs from "../pages/AuditLogs";
import StorageConfig from "../pages/StorageConfig";
import BulkScheduler from "../pages/ScheduleSync";
import MasterData from "../pages/MasterData";

import Login from "../pages/Login";
import ChangePassword from "../common/forms/ForgotPassword";
import LeaveManagement from "../pages/Modules/LeaveManagement";
import EmployeeLeaveView from "../pages/EmployeeLeaveView";
import EmployeeTypeTable from "../common/components/EmployeeLeaveType";
import EmployeeLeaveRequestView from "../common/components/LeaveManagement/LeaveRequestView";
import EmployeeLeaveApprovalView from "../common/components/LeaveManagement/LeaveApprovalView";
import LeaveConfigurationScreen from "../pages/Settings/Leave Management/Leave Configuration/LeaveConfiguration";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/dashboard" element={<Dashboard />} />

      {/* Specific employee routes MUST come before the base /employee route */}
      <Route path="/employee/new" element={<EmployeeProfile />} />
      <Route path="/employee/:id" element={<EmployeeProfile />} />
      <Route path="/employee" element={<Employee />} />

      <Route path="/settings" element={<Settings />} />
      <Route path="/branch" element={<Branch />} />
      <Route path="/users" element={<Users />} />
      <Route path="/job-title" element={<JobTitle />} />
      <Route path="/department" element={<Department />} />
      <Route path="/role" element={<Role />} />
      <Route path="/client" element={<Client />} />
      <Route path="/leave-management" element={<LeaveManagement />} />
      <Route
        path="/leave-management/request"
        element={<EmployeeLeaveRequestView />}
      />
      <Route
        path="/leave-management/approval"
        element={<EmployeeLeaveApprovalView />}
      />
      <Route path="/leave/employee/:id" element={<EmployeeLeaveView />} />
      <Route path="/sync-sched" element={<BulkScheduler />} />
      <Route path="/leave-type" element={<EmployeeTypeTable />} />
      <Route path="/importLogs" element={<ImportHistory />} />
      <Route path="/storageConfig" element={<StorageConfig />} />
      <Route path="/auditLogs" element={<AuditLogs />} />
      <Route path="/masterData" element={<MasterData />} />
      <Route path="/leave-config" element={<LeaveConfigurationScreen />} />
    </Routes>
  );
};

export default AppRoutes;